module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"template":"Шаблон","from":"из","chooseInterviewer":"Вопросы будет озвучивать","cancel":"Отмена","choose":"Выбрать","templateAiInterview":"Подбор и озвучка вопросов от ИИ","templateAiInterviewDescription":"ИИ подберет и озвучит вопросы для вашей вакансии. Вы сможете внести изменения при необходимости."}}')
  delete Component.options._Ctor
}
